import React from "react";
import "./Studiedjungeln.css";
import CodeRain from "../components/CodeRain";
import BackButton from "../components/BackButton";

// Images
import studiedjungeln from "../assets/studiedjungeln.png";
import profilsida from "../assets/profilsida.png";
import poäng from "../assets/poäng.png";
import övning from "../assets/övning.png";
import exercises from "../assets/exercises.png";

const Studiedjungeln = () => {
  return (
    <div className="studiedjungeln-page">
      <CodeRain />
      <div className="studiedjungeln-content">
        <BackButton label="Back to Projects" />

        <h1>Studiedjungeln</h1>
        <p>
          <strong>Studiedjungeln</strong> is a full-stack learning platform I designed and built
          end-to-end. The idea came from a decade working in schools - I saw the gap between
          what was available digitally and what actually engaged and taught children effectively.
          This project is the result of combining that domain knowledge with production-grade
          software engineering.
        </p>

        <p>
          <strong>Stack:</strong> React (SPA), Java + Spring Boot (REST API), MySQL. The architecture
          follows a clean separation of concerns - stateless backend, relational persistence
          layer, component-based frontend - covering subjects including language, mathematics,
          and geography.
        </p>

        <p>
          Core features: user registration and authentication, an exercise engine that
          randomises answer sets from the database to prevent memorisation, and a persistent
          points system tracking individual progress across sessions.
        </p>

        <p>
          Key engineering decisions: a normalised relational schema designed with extensibility
          in mind, JWT-based stateless authentication, and a deliberately crafted UX - motion,
          colour, and layout chosen to keep young users engaged without becoming a distraction.
        </p>

        <p>
          <strong>Roadmap:</strong> Cloud deployment on AWS, a React Native companion app,
          expanded subject catalogue, and a teacher-facing dashboard for monitoring class
          progress - turning this into a platform suitable for institutional adoption.
        </p>

        <h2 style={{ marginTop: "50px" }}>📸 Screenshots</h2>
        <div className="image-row">
          <img src={studiedjungeln} alt="Studiedjungeln home screen" />
          <img src={profilsida} alt="User profile page" />
          <img src={övning} alt="Exercise example" />
          <img src={exercises} alt="Exercise selection" />
          <img src={poäng} alt="Points system" />
        </div>
      </div>
    </div>
  );
};

export default Studiedjungeln;
